import React from 'react';
import { Button, Stack } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * UA / EN toggle matching LandingPage styling.
 */
export default function PublicLocaleToggle({
  lang,
  onChange,
  labelUk = 'UA',
  labelEn = 'EN',
  sx,
  tone = 'dark',
}) {
  const btnSx = (active) => {
    if (active) {
      return {
        minWidth: 52,
        color: '#ffffff',
        bgcolor: '#1976d2',
        borderColor: 'transparent',
        '&:hover': { bgcolor: '#1565c0' },
        '& .MuiButton-label': { color: '#ffffff' },
      };
    }
    return tone === 'light'
      ? { minWidth: 52, color: '#0f172a', borderColor: 'rgba(15, 23, 42, 0.35)' }
      : { minWidth: 52, color: '#fff', borderColor: 'rgba(166, 180, 255, 0.5)' };
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={sx}>
      <Button
        size="small"
        variant={lang === 'uk' ? 'contained' : 'outlined'}
        onClick={() => onChange('uk')}
        sx={btnSx(lang === 'uk')}
      >
        {labelUk}
      </Button>
      <Button
        size="small"
        variant={lang === 'en' ? 'contained' : 'outlined'}
        onClick={() => onChange('en')}
        sx={btnSx(lang === 'en')}
      >
        {labelEn}
      </Button>
    </Stack>
  );
}

PublicLocaleToggle.propTypes = {
  lang: PropTypes.oneOf(['uk', 'en']).isRequired,
  onChange: PropTypes.func.isRequired,
  labelUk: PropTypes.string,
  labelEn: PropTypes.string,
  sx: PropTypes.object,
  tone: PropTypes.oneOf(['dark', 'light']),
};
